import { NoDataException } from '../../../utils/exceptions/nodataexistsexception';
import { TransactionHistoryDto, TransactionHistoryDtoImpl } from './transactionhistorydto';
import { DateTransform } from '../../../ui/toolkit/datetransform/datetransform';
import { BaseContext } from '../../../utils/basecontext';
import { Strings } from '../../../utils/resources/strings';

export class TransactionHistoryBuilder
{
    constructor(private transactionHistoryList: any, private context: BaseContext)
    {
        if(transactionHistoryList.transactionDetailsList  === undefined)
        {
            throw new NoDataException("Transaction History doesnt exists");
        }
    }

    buildAll(): TransactionHistoryDto[]
    {
        return this.parseTransactionHistoryDetailsResponse();
    }
    
    private parseTransactionHistoryDetailsResponse(): TransactionHistoryDto[]
    {
        let listOfTransactionHistory: TransactionHistoryDto[] = [];
        
        let transactionHistoryDto = null;
        this.transactionHistoryList.transactionDetailsList.forEach((transactionHistoryDetailsItem: any) =>
        {
            transactionHistoryDto = new TransactionHistoryDtoImpl();
            transactionHistoryDto.setTitle(transactionHistoryDetailsItem.englishToneName);
            transactionHistoryDto.setTimeStamp(DateTransform.formatHistoryTimestamp(transactionHistoryDetailsItem.subscriptionDate));
            transactionHistoryDto.setTransactionType(transactionHistoryDetailsItem.transactionType);
            transactionHistoryDto.setChannel(transactionHistoryDetailsItem.channel);
            transactionHistoryDto.setPrice(transactionHistoryDetailsItem.transactionType ===
                this.context.getResources().getString(Strings.Deactivated)
                ? this.context.getResources().getString(Strings.NA) :
                transactionHistoryDetailsItem.callCharge + " " + this.context.getResources().getString(Strings.price_unit));
            // transactionHistoryDto.setDuration(transactionHistoryDetailsItem.duration !== undefined ? transactionHistoryDetailsItem.duration : "");
                transactionHistoryDto.setDuration(this.getValidityDays(transactionHistoryDetailsItem.validityDays));
            listOfTransactionHistory.push(transactionHistoryDto);
        });
        return listOfTransactionHistory;
    }

   private getValidityDays(days:string):string{
        if(days === "N/A")
        {
            return days;
        }
        else
        {
            if(+days === 1)
            {
                return days+" "+this.context.getResources().getString(Strings.day);
            }
            else{
                return days+" "+this.context.getResources().getString(Strings.days);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/transactionhistory/transactionhistorybuilder.ts